import Cookies from 'js-cookie';
import Axios from "axios";

const cookie = Cookies.withAttributes({
    path: '/',
    domain: process.env.VUE_APP_WRAPPER_COOKIE_DOMAIN,
    expires: 2
});

export default {
    async init() {

        const url_token = this.getTokenFromUrl();

        if (url_token) {
            cookie.set('bs_token', url_token)
            location.href = '/';
            return true;
        }

        this.customerId = 0;
        try{
            this.customerId = parseInt(cookie.get('bs_customer_id'));
        }catch (e){

        }

        await this.refreshToken();

        const self = this;

        //Setup reload of the token every 20 minutes, 1 200 000ms = 20min
        setInterval(function () {
            self.refreshToken();
        }, 1200000);

    },

    isCustomer(name) {
      if(name === 'apoteket') {
          return [47, 48].includes(this.customerId);
      }

      return null;
    },

    async refreshToken() {

        let token = cookie.get('bs_token');

        if (!token) {
            this.resetCookies();
            return false;
        }

        try {
            const response = await Axios.post('https://sso.brandsafe.no/refresh', null, {headers: {'Authorization': 'Bearer ' + token}});

            this.populateCookies(response.data);

            this.populateLocalStorage(response.data);

            return true;
        } catch (error) {
            this.resetCookies();

            this.resetLocalStorage();

            // if apoteket, redirect to entra-id login
            let suffix = '';
            if(this.isCustomer('apoteket')) {
                suffix = '/apoteket';
            }

            location.href = process.env.VUE_APP_LOGIN_URL+suffix;
            return true;
        }
    },

    getTokenFromUrl() {
        let url_string = window.location.href;
        let url = new URL(url_string);

        return url.searchParams.get('token');
    },

    populateLocalStorage(data) {

        let active_account = data.hasOwnProperty('active_account') ? data.active_account : {};

        localStorage.setItem('active_account', JSON.stringify(active_account));

        let user = {
            id: data.id,
            name: data.name,
            phone: data.phone,
            email: data.email,
            language: data.language
        };

        localStorage.setItem('user', JSON.stringify(user));
    },

    populateCookies(data) {

        cookie.set('bs_token', data.jwt.token);
        cookie.set('bs_token_valid_until', data.jwt.valid_until);
        cookie.set('bs_user_id', data.id);
        cookie.set('bs_customer_id', data.customer_id);
        cookie.set('bs_departments', data.departments);
        cookie.set('bs_active_department_id', data.departments[0]);
        cookie.set('bs_name', data.name);
        cookie.set('bs_username', data.username);
        cookie.set('bs_language', data.language);
        cookie.set('bs_profile', data.profile);
        cookie.set('bs_role', data.role.title);
    },

    resetLocalStorage() {
        localStorage.removeItem('user');
        localStorage.removeItem('active_account');
    },

    resetCookies() {
        cookie.remove('bs_token');
        cookie.remove('bs_token_valid_until');
        cookie.remove('bs_user_id');
        // for apoteket login page redirection, keep bs_customer_id cookie
        if(!this.isCustomer('apoteket')) {
            cookie.remove('bs_customer_id');
        }
        cookie.remove('bs_departments');
        cookie.remove('bs_active_department_id');
        cookie.remove('bs_name');
        cookie.remove('bs_username');
        cookie.remove('bs_language');
        cookie.remove('bs_profile');
        cookie.remove('bs_role');
    }
}
